
export default function SwitchScanPrivacyPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto",textAlign: "left" }}>
      <h1>Privacy Policy for Switch Scan</h1>
      <p>
        <strong>Last Updated:</strong> 01 April 2026
      </p>

      <p>
        Switch Scan we, respects your privacy. This Privacy
        Policy explains how we collect, use, and protect your information when
        you use our mobile application ("App") available on the Google Play
        Store.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>1.1 Personal Information</h3>
      <p>To provide access to the app, we collect the following information:</p>
      <ul>
        <li>Mobile Number (used only for login and account identification)</li>
      </ul>

      <h3>1.2 QR Code Scanning Data</h3>
      <p>
        Switch Scan allows users to scan unique QR codes placed on each bus.
        When you scan a QR code:
      </p>
      <ul>
        <li>We only read the encoded bus ID or route information.</li>
        <li>We do not store the QR image.</li>
        <li>No personal data is linked to QR scans.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To log you into the app using your mobile number</li>
        <li>To display bus information after QR scan</li>
        <li>To ensure the proper functioning of the app</li>
      </ul>

      <h2>3. Permissions Used</h2>

      <h3>Camera Permission</h3>
      <p>
        Used only for scanning QR codes placed on buses. We do not store or
        upload images.
      </p>

      <h3>Internet Access</h3>
      <p>Used to validate login and fetch bus information.</p>

      <h2>4. Data Security</h2>
      <p>
        We take necessary security measures to protect your data, including
        secure authentication and encrypted communication. However, no method is
        100% secure.
      </p>

      <h2>5. Children’s Privacy</h2>
      <p>
        Switch Scan is not intended for children under 13. We do not knowingly
        collect data from children.
      </p>

      <h2>6. Data Retention</h2>
      <p>
        We retain your mobile number only while your account is active. Minimal
        logs may be retained for security purposes even after uninstalling the
        app.
      </p>

      <h2>7. Your Rights</h2>
      <p>You may request:</p>
      <ul>
        <li>Deletion of your account</li>
        <li>Removal of your mobile number</li>
      </ul>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. The updated version will
        be posted here with the new effective date.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        <strong>Email:</strong> itconnect@switchmobilityev.com
        <br />
        <strong>Developer/Company Name:</strong> Switch Mobility Ltd
      </p>
    </div>
  );
}